import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './AccountMenu.module.scss'
import { Heading } from 'components/Heading'
import { AccountMenuItem } from './AccountMenuItem'
import { Stack } from 'components/Stack'

export const AccountMenu: FC = (_props) => {
  const { t } = useTranslation()

  return (
    <Stack className={styles.accountMenu}>
      <Heading align="right">{t('account.heading')}</Heading>
      <nav>
        <Stack component="ul" space="medium">
          <AccountMenuItem path="/account" text={t('account.menu.personal_details')} />
          <AccountMenuItem path="/account/reset-password" text={t('account.menu.reset_password')} />
          <AccountMenuItem
            path="/account/notifications"
            text={t('account.menu.email_notifications')}
          />
          <AccountMenuItem path="/account/language" text={t('account.menu.language')} />
        </Stack>
      </nav>
    </Stack>
  )
}

AccountMenu.displayName = 'AccountMenu'
